/** PURE_IMPORTS_START .._.._Observable,.._.._operator_max PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { max } from '../../operator/max';
Observable.prototype.max = max;
//# sourceMappingURL=max.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/operator/max.js
// module id = 517
// module chunks = 0